module.exports = __webpack_public_path__ + "adb0d062b8d53322008ba2b503688162.svg";